


















import { defineComponent } from "@nuxtjs/composition-api";
import { SfButton } from "@storefront-ui/vue";
import { useUser } from "@wemade-vsf/customer";
import { useUiState } from "@wemade-vsf/composables";

export default defineComponent({
    name: "LoginBanner",
    components: {
        SfButton,
    },
    props: {
        linkText: {
            type: String,
            default: "Logg inn her",
        },
        title: {
            type: String,
            default: "Logg inn på kontoen din",
        },
        description: {
            type: String,
            default: "",
        },
    },
    setup() {
        const { isAuthenticated } = useUser();
        const { toggleLoginModal } = useUiState();
        return {
            isAuthenticated,
            toggleLoginModal,
        };
    },
});
